import { IExamInfo } from '@repositories/model/transfer/IExamInfo';
import { IProject } from '@repositories/model/IProject';
import { IPageSOBP, isSamePageOnlySOBP, NeoStroke } from '@neolab-libs/nl-lib3-common';
import PdfToQAMapper, { QuestionNameToPageInfo } from '@/common/objects/QuestionAnswerToPageMapping/PdfToQAMapper';

type CodeToStrokes = Record<string, NeoStroke[]>;

interface INeoPenStoreLike {
	requestStrokeRecognition(locale: string, strokes: NeoStroke[]): Promise<string>;
}

export default class StrokeRecognizer {

	public examList: IExamInfo[];
	public wholeStrokes: NeoStroke[];
	public languageCode: string;
	public ncodeRange: { start: IPageSOBP, end: IPageSOBP };

	private neoPenStore: INeoPenStoreLike;

	constructor(neoPenStore: INeoPenStoreLike) {
		this.neoPenStore = neoPenStore;
	}

	public async recognize(): Promise<Record<string, string>> {
		
		// 1) classify strokes
		const grouped = this.classifyStrokes(this.wholeStrokes, this.ncodeRange, this.examList);

		const keys = Object.keys(grouped);
		const results: Record<string, string> = {};

		for (const code of keys) {
			const strokes = grouped[code];
			if (!strokes || strokes.length === 0) {
				results[code] = "";
				continue;
			}
			try {
				const text = await this.neoPenStore.requestStrokeRecognition(this.languageCode, strokes);
				results[code] = text ?? "";
			} catch {
				results[code] = "";
			}
		}

		return results;
	}

	private classifyStrokes(wholeStrokes: NeoStroke[], ncodeRange: { start: IPageSOBP, end: IPageSOBP }, examInfoArray: IExamInfo[]) {
	
			const codeToStrokes = {};
	
			const sobp: IPageSOBP = {
				section: ncodeRange.start.section,
				owner: ncodeRange.start.owner,
				book: ncodeRange.start.book,
				page: ncodeRange.start.page
			};
	
			const questionToPageIndexMapping = PdfToQAMapper.readQuestionNameToPageIndex(examInfoArray);
			
			for (let examIndex = 0; examIndex < examInfoArray.length; examIndex++) {
				const type = examInfoArray[examIndex].type;
				const questions = examInfoArray[examIndex].questions;
	
				for (let questionIndex = 0; questionIndex < questions.length; questionIndex++) {
					let questionText = (examIndex + 1) + "-" + (questionIndex + 1);
					let code = examInfoArray[examIndex].code + "-" + (questionIndex + 1);
	
					const { page } = questionToPageIndexMapping[questionText];
	
					const contentSobp = { ...sobp, page: sobp.page + page };
	
					const strokes = wholeStrokes.filter((stroke) => isSamePageOnlySOBP(stroke.sobp, contentSobp));
					
					codeToStrokes[code] = [];
					
					for (const stroke of strokes) {
						if (stroke.dotArray[0]?.y > 24) {
							codeToStrokes[code].push(stroke);
						}
	
					}
				}
			}
	
			return codeToStrokes;
		}
}


